import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class InvalidEmailError extends CodedError {
  static get errorName() {
    return errorCodes.invalidEmailError.code;
  }

  constructor(message: string = errorCodes.invalidEmailError.message) {
    super(message);
    this.code = errorCodes.invalidEmailError.code;
    this.message = `${message} ${errorCodes.invalidEmailError.code}`;
    this.name = errorCodes.invalidEmailError.name;
  }
}
